module.exports = __webpack_public_path__ + "img/Jump Casting47.3b1f7361.jpg";